module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAANCAYAAABy6+R8AAAAzUlEQVQoU52SMQ6CQBBF5y+JLVLZaespvAWUWgDLCTwFlVYugcbSY3gJ7aWxMh4AxoyRZENcJG43u/Py/98ZhGE48X0/B7AGMCXrFEUBu47jeOV5noHWesfMC2bOyrK82019QCl1UkpFSNP0wczLsYAx5ixK3LfhUhBA3gYhySCW2raNqqp6A4OQC3BCQ4DE+WpPa31pmiazLXXWnJDr2+X+f2jMnDrlJElmAK4y3D0RzX9txAc4ENENsntBEOTMvAHgu/Iw85OIjnVdb1/Ea4wPemRiQgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/bianji_icon.png
// module id = TuPo
// module chunks = 1